import { ModuleWithProviders, NgModule  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/** O3 Framework Libraries  */
import { NgNavigationModule } from '@al/ng-navigation-components';
import { NgGenericComponentsModule } from '@al/ng-generic-components';
import { CircleAlLogoComponent } from './components/circle-al-logo/circle-al-logo.component';
import { CircleSuccessComponent } from './components/circle-success/circle-success.component';
import { AlRolodexWidgetComponent } from './components/al-rolodex-widget/al-rolodex-widget.component';
import { AlUserListComponent } from './components/al-user-list/al-user-list.component';
import { AlUserTileComponent } from './components/al-user-tile/al-user-tile.component';
import { ButtonModule } from 'primeng-lts/button';

@NgModule({
    declarations: [
        CircleAlLogoComponent,
        CircleSuccessComponent,
        AlRolodexWidgetComponent,
        AlUserListComponent,
        AlUserTileComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgNavigationModule,
        NgGenericComponentsModule,
        ButtonModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgNavigationModule,
        NgGenericComponentsModule,
        CircleAlLogoComponent,
        CircleSuccessComponent,
        AlRolodexWidgetComponent,
        AlUserListComponent,
        AlUserTileComponent
    ],
    providers: []
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
        ngModule: SharedModule,
        providers: []
    };
}
}
